import { BankBtns } from './BankBtns.js'
import { useEffect, useState } from "react"

import './Banking.css'
import { BankLists } from './BankLists.js'
import { Breakdown, Constants, FuturePayments, Spread } from './BankStats.js'
import rest from '../../utils/rest.js'

export function Sys_Banking({orientation}) {
    // temp dummy is set
    const [getData, setData] = useState({
        spread: {},
        breakdown: {
            spending: 1,
            savings: 1,
            living: 1
        },
        future: [],
        constants: {}
    })

    useEffect(() => {
        refresh()
    }, [])

    function refresh(pause_time = 0) { 
        rest.JSONRequest('bank', 'GET', {}, {}).then(async (response) => {
            await new Promise(resolve => setTimeout(resolve, pause_time))

            if(response.status == 200) {
                setData({...getData, 
                    future: response.data.future, 
                    constants: response.data.constants, 
                    savings: response.data.savings, 
                    bills: response.data.bills,
                    spread: response.data.spread,
                    breakdown: response.data.breakdown
                })
                console.log(getData)
            }
        })
    }

    const landscape = () => {
        return (
            <div className='bank_main'>
                <div className='bank_salad'>
                    <BankBtns data={getData} refresh={refresh}/>
                    <Spread data={getData} refresh={refresh}/>
                    <Breakdown data={getData}/>
                    <Constants data={getData} refresh={refresh}/>
                    <FuturePayments data={getData}/>
                </div>
                <BankLists data={getData} refresh={refresh}/>
            </div>
        )
    }

    const portrait = () => {
        return (
            <div className='bank_main'>
                <div className='bank_salad'>
                    <BankBtns data={getData} refresh={refresh}/>
                    <Spread data={getData}/>
                    <Breakdown data={getData}/>
                    <Constants data={getData} refresh={refresh}/>
                    <FuturePayments data={getData}/>
                </div>
                <BankLists data={getData} refresh={refresh}/>
            </div>
        )
    }

    return orientation.substring(0, 8) == "portrait" ? portrait() : landscape()
}